"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoView = void 0;
const video_player_1 = require("@shared-modules/components/video-player");
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const VideoView = (props) => {
    const { metaUrlBase, metadata, onPlay, onPause } = props;
    const previewUrl = metaUrlBase + metadata.image;
    const videoUrl = metaUrlBase + metadata.video;
    return react_1.default.createElement(video_player_1.VideoPlayer, { preview: previewUrl, src: videoUrl, onReset: onPause, onPlay: onPlay });
};
exports.VideoView = VideoView;
